import React, { useState, useEffect, useContext } from 'react';
import Loading from '../components/Loading';
import EmployeeInfo from '../components/detail/EmployeeInfo';
import InvoiceInfo from '../components/detail/InvoiceInfo';
import EmpHourInfo from '../components/detail/EmpHourInfo';
import EmpCourseInfo from '../components/detail/EmpCourseInfo';
import EmpCertificateInfo from '../components/detail/EmpCertificateInfo';
import '../styles/pages/emp-details.scss';
import ErrorPage from './error';
import { navigate, usePath } from 'hookrouter';
import { GetEmployeeCertificates, GetEmployeeInfo } from '../functions/fetch/employee';
import { DataContext } from '../store';
import { DataContext as CourseTableDataContext } from '../stores/employee-course-table-store';

import { useTranslation } from 'react-i18next';
import { EMPLOYEE_DETAILS_INFORMATION_LABEL, EMPLOYEE_DETAILS_BILLING_LABEL, EMPLOYEE_DETAILS_HOURS_LABEL, EMPLOYEE_DETAILS_COURSE_LABEL, EMPLOYEE_DETAILS_CERTIFICATIONS_LABEL, EMPLOYEE_DETAILS_OFFICE_LABEL, EMPLOYEE_DETAILS_COMPANY_LABEL, EMPLOYEE_DETAILS_START_DATE_LABEL, EMPLOYEE_DETAILS_BIRTH_DATE_LABEL, EMPLOYEE_DETAILS_ADRESS_LABEL, EMPLOYEE_DETAILS_EMAIL_LABEL, EMPLOYEE_DETAILS_NAV_MENU_BACK_BUTTON } from '../i18n/keyConstants';


const EmpDetails = (props) => {
    const [employee, setEmployee] = useState();
    const [bosses, setBosses] = useState();
    const [id, setEmployeeId] = useState(props.empId);
    const [loading, setIsLoading] = useState(true);
    const [loadingCourses, setIsLoadingCourses] = useState(true);
    const [loadingCertificates, setIsLoadingCertificates] = useState(true);
    const [subordinates, setSubordinates] = useState();
    const [error, setError] = useState();
    const [invoiceInfo, setInvoiceInfo] = useState();
    const [courseInfo, setCourseInfo] = useState();
    const [certificateInfo, setCertificateInfo] = useState();
    const [hourInfo, setHourInfo] = useState(null);
    const [firstHourDate, setFirstHourDate] = useState();
    const [activeTab, setActiveTab] = useState();
    const [hasBillingPermission, setBillingPermission] = useState(false);
    const [hasInternalHoursPermission, setInternalHoursPermission] = useState(false);
    const [hasCoursesPermission, setCoursesPermission] = useState(false);
    const [hasCertificatesPermission, setCertificatesPermission] = useState(false);
    const [isMyself, setIsMyself] = useState(false);

    const { t } = useTranslation(['employeeDetails']);


    const {
        store: { user },
    } = useContext(DataContext);

    const {
        store: { filters, isResettingFilters },
        dispatch } = useContext(CourseTableDataContext);

    const path = usePath();

    useEffect(() => {
        const array = path.split('/');
        const empId = array[2];
        const activeTab = array[3];

        setActiveTab(activeTab);
        setEmployeeId(decodeURIComponent(empId));
    }, [path]);

    useEffect(() => {
        dispatch({ type: 'RESET_FILTERS' });
        setInvoiceInfo(null);
        setIsLoading(true);
        FetchEmployee();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    useEffect(() => {
        if (!isResettingFilters) {
            setIsLoadingCourses(true);
            if (hasCoursesPermission) {
            setIsLoadingCertificates(true);
                getEmployeeCourses();
            }
            if (hasCertificatesPermission) {
                GetEmployeeCertificates();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isResettingFilters]);

    useEffect(() => {
        if (hasCoursesPermission) {
            setIsLoadingCourses(true);
            getEmployeeCourses();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hasCoursesPermission]);

    useEffect(() => {
        if (hasCoursesPermission) {
            setIsLoadingCourses(true);
            getEmployeeCourses();
        }
    }, [filters]);

    async function getEmployeeCourses() {
        setCourseInfo(null);
        const infoResult = await GetEmployeeInfo(id, 'courses', JSON.stringify(filters));
        if (infoResult === null) {
            return;
        }
        if (infoResult.err) {
            setError(infoResult.err);
        } else {
            const { courses } = infoResult.data;
            setCourseInfo(courses);
            setIsLoadingCourses(false);
        }
    }

    async function FetchEmployee() {
        const res = await GetEmployeeInfo(id, 'info');
        if (res === null) return;
        if (res.err) {
            setError(res.err)
            setIsLoading(false);
        }
        else {
            const { employee, bosses, subordinates, isBossOfEmp, isOfficeBossOfEmp, isMyself } = res.data;
            setEmployee(employee);
            setBosses(bosses);
            setSubordinates(subordinates);

            const canSeeInternalHours = user.isAdmin || user.isSalesOrEco || isBossOfEmp || isOfficeBossOfEmp || isMyself;
            const canSeeCourses = user.isAdmin || user.isSalesOrEco || isBossOfEmp || isOfficeBossOfEmp || isMyself || user.isExlAdmin;
            const canManageCertificates = user.isAdmin || user.isSalesOrEco || isBossOfEmp || isOfficeBossOfEmp || isMyself || user.isExlAdmin || user.isExlCertificateAdmin;
            const canSeeBilling = user.isAdmin || user.isSalesOrEco || isBossOfEmp || isOfficeBossOfEmp;

            CheckForNonAuthorizedNavigation(canSeeInternalHours, canSeeBilling, canSeeCourses, canManageCertificates);
            setBillingPermission(canSeeBilling);
            setInternalHoursPermission(canSeeInternalHours);
            setCoursesPermission(canSeeCourses);
            setCertificatesPermission(canManageCertificates);
            setIsMyself(isMyself);
            setIsLoading(false);

            if (canSeeInternalHours) {
                const infoResult = await GetEmployeeInfo(id, 'invoice');

                if (infoResult === null) {
                    return;
                }
                if (infoResult.err) {
                    setError(infoResult.err);
                } else {
                    const { invoiceInfo, internHourInfo, firstLoggedInternHour } = infoResult.data;
                    setInvoiceInfo(invoiceInfo);
                    setHourInfo(internHourInfo);
                    setFirstHourDate(firstLoggedInternHour);
                }
            }
            if (canManageCertificates) {
                setCertificateInfo(null);

                const res = await GetEmployeeCertificates(id);
                if (res === null) return;
                if (res.err) {
                    setError(res.err)
                }
                else {
                    setCertificateInfo(res.data);
                    setIsLoadingCertificates(false);
                }
            }
        }
    }

    const CheckForNonAuthorizedNavigation = (canSeeBilling, canSeeInternalHours, canSeeCourses, canManageCertificates) => {
        const array = path.split('/');
        const activeTab = array[3];
        if (!canSeeBilling && activeTab === 'billing') {
            navigate('info');
        } else if (!canSeeInternalHours && (activeTab === 'billing' || activeTab === 'hours')) {
            navigate('info');
        } else if (activeTab === 'courses' && !canSeeCourses) {
            navigate('info');
        } else if (activeTab === 'certificates' && !canManageCertificates) {
            navigate('info');
        }
    };

    const handleTabClick = (e) => {
        const tabName = e.target.id.split('-')[0];
        navigate(tabName);
    };

    const content = loading ? (
        <Loading />
    ) : error ? (
        <ErrorPage error={error} />
    ) : (
        <section className='details'>
            <div className='card-body bg-light-licorice'>
                <div className='card-profile-img text-center margin-bottom-10px margin-top-10px'>
                    <img className='margin-none' src={employee.photo} alt='user icon' />
                </div>
                <h3 className='text-center c-white margin-bottom-none'>{employee.name}</h3>
                <p className='text-center c-light-grey'>{employee.role}</p>
                <span className='details-back-btn'>
                    <button className='btn btn-outline-secondary d-flex c-white border-0' onClick={() => window.history.back()}>
                        <span className='oi oi-chevron-left padding-right-10px'></span>
                        <span className='d-none d-sm-block'>{t(EMPLOYEE_DETAILS_NAV_MENU_BACK_BUTTON)}</span>
                    </button>
                </span>
            </div>
            <ul className='nav nav-tabs container padding-top-15px' role='tablist'>
                <li className='nav-item' onClick={handleTabClick}>
                    <a
                        className={'nav-link ' + (!activeTab || activeTab === 'info' ? 'active' : '')}
                        id='info-tab'
                        data-toggle='tab'
                        href='#info'
                        role='tab'
                        aria-controls='info'
                        aria-selected='true'>
                        {t(EMPLOYEE_DETAILS_INFORMATION_LABEL)}
                    </a>
                </li>
                {hasBillingPermission && (
                    <li className='nav-item' onClick={handleTabClick}>
                        <a
                            className={'nav-link ' + (activeTab && activeTab === 'billing' ? 'active' : '')}
                            id='billing-tab'
                            data-toggle='tab'
                            href='#billing'
                            role='tab'
                            aria-controls='invoice'
                            aria-selected='false'>
                            {t(EMPLOYEE_DETAILS_BILLING_LABEL)}
                        </a>
                    </li>
                )}
                {hasInternalHoursPermission && (
                    <li className='nav-item' onClick={handleTabClick}>
                        <a
                            className={'nav-link ' + (activeTab && activeTab === 'hours' ? 'active' : '')}
                            id='hours-tab'
                            data-toggle='tab'
                            href='#hours'
                            role='tab'
                            aria-controls='hours'
                            aria-selected='false'>
                            {t(EMPLOYEE_DETAILS_HOURS_LABEL)}
                        </a>
                    </li>
                )}
                {hasCoursesPermission && (
                    <li className='nav-item' onClick={handleTabClick}>
                        <a
                            className={'nav-link ' + (activeTab && activeTab === 'courses' ? 'active' : '')}
                            id='courses-tab'
                            data-toggle='tab'
                            href='#courses'
                            role='tab'
                            aria-controls='courses'
                            aria-selected='false'>
                            {t(EMPLOYEE_DETAILS_COURSE_LABEL)}
                        </a>
                    </li>
                )}
                {hasCertificatesPermission && (
                    <li className='nav-item' onClick={handleTabClick}>
                        <a
                            className={'nav-link ' + (activeTab && activeTab === 'certificates' ? 'active' : '')}
                            id='certificates-tab'
                            data-toggle='tab'
                            href='#certificates'
                            role='tab'
                            aria-controls='certificates'
                            aria-selected='false'>
                            {t(EMPLOYEE_DETAILS_CERTIFICATIONS_LABEL)}
                        </a>
                    </li>
                )}
            </ul>
            <div className='tab-content'>
                <div
                    className={'tab-pane fade ' + (activeTab && activeTab === 'info' ? 'show active' : '')}
                    id='info'
                    role='tabpanel'
                    aria-labelledby='info-tab'>
                    <EmployeeInfo
                        employee={employee}
                        subordinates={subordinates}
                        bosses={bosses}
                        setEmployeeId={setEmployeeId}
                        loading={loading}
                    />
                </div>

                {hasBillingPermission && invoiceInfo && (
                    <div
                        className={'tab-pane fade ' + (activeTab && activeTab === 'billing' ? 'show active' : '')}
                        id='billing'
                        role='tabpanel'
                        aria-labelledby='billing-tab'>
                        <InvoiceInfo invoiceInfo={invoiceInfo} />
                    </div>
                )}
                {hasInternalHoursPermission && hourInfo && (
                    <div
                        className={'tab-pane fade ' + (activeTab && activeTab === 'hours' ? 'show active' : '')}
                        id='hours'
                        role='tabpanel'
                        aria-labelledby='hours-tab'>
                        <EmpHourInfo hourInfo={hourInfo} firstDate={new Date(firstHourDate)} />
                    </div>
                )}
                {(user.isExlAdmin || isMyself || hasCoursesPermission) && (
                    <div
                        className={'tab-pane fade ' + (activeTab && activeTab === 'courses' ? 'show active' : '')}
                        id='courses'
                        role='tabpanel'
                        aria-labelledby='courses-tab'>
                        <EmpCourseInfo courses={courseInfo} id={id} isLoading={loadingCourses} />
                    </div>
                )}
                {(user.isExlAdmin || isMyself || hasCertificatesPermission) && (
                    <div
                        className={'tab-pane fade ' + (activeTab && activeTab === 'certificates' ? 'show active' : '')}
                        id='certificates'
                        role='tabpanel'
                        aria-labelledby='certificates-tab'>
                        <EmpCertificateInfo certifications={certificateInfo} id={id} isLoading={loadingCertificates} canManageCertificates={hasCertificatesPermission} />
                    </div>
                )}
            </div>
        </section>
    );
    return content;
};

export default EmpDetails;
